module.exports = __webpack_public_path__ + "static/media/filter.22465a30.svg";